import { TabsContent } from 'design-system';

import type { FactsheetDetails, FactsheetTab } from '@/features/factsheet/types';

interface ChartTabContentProps {
  factsheet: FactsheetDetails;
  contentTabs: FactsheetTab[];
}

const ChartTabContent = ({ factsheet, contentTabs }: ChartTabContentProps) => (
  <>
    {contentTabs.map(tab => (
      <TabsContent
        key={`${factsheet.code}-chart-${tab.name}`}
        value={tab.name}
        className='w-full flex-1 flex-grow overflow-auto pt-4'
      >
        {tab.component}
      </TabsContent>
    ))}
  </>
);

export default ChartTabContent;
